//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import IngresoAjusteManager from '../../../Common/Managers/IngresoAjusteManager';

export const GET_DATA_INGRESO_AJUSTES = 'GET_DATA_INGRESO_AJUSTES';
export const RECEIVE_DATA_INGRESO_AJUSTES = 'RECEIVE_DATA_INGRESO_AJUSTES';
export const CHANGE_DATA_INGRESO_AJUSTES = 'CHANGE_DATA_INGRESO_AJUSTES';
export const INITIAL_STATE_INGRESO_AJUSTES = 'INITIAL_STATE_INGRESO_AJUSTES';
export const EXPANDIR_ROW_INGRESO_AJUSTES = 'EXPANDIR_ROW_INGRESO_AJUSTES';
export const SUCCESS_INGRESO_AJUSTES = 'SUCCESS_INGRESO_AJUSTES';
export const LIMPIAR_INGRESO_AJUSTES = 'LIMPIAR_INGRESO_AJUSTES';
export const ELIMINAR_INGRESO_AJUSTES = 'ELIMINAR_INGRESO_AJUSTES';
export const EDITAR_INGRESO_AJUSTES = 'EDITAR_INGRESO_AJUSTES';
export const CONFIRMAR_INGRESO_AJUSTES = 'CONFIRMAR_INGRESO_AJUSTES';
export const DENEGAR_INGRESO_AJUSTES = 'DENEGAR_INGRESO_AJUSTES';
export const SELECT_MOTIVO_AJUSTE_COMBO = 'SELECT_MOTIVO_AJUSTE_COMBO';
export const CHANGE_IMPORTE_SIN_IVA = 'CHANGE_IMPORTE_SIN_IVA';


//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _vistaCliente, _currentAccount, _motivoAjusteId = null;

/**
 * Action que obtiene el estado inicial.
 * @param {any} currentScope
 * @param {any} currentAccount
 */
export function getScreenData(currentScope, currentAccount) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        let state = getState();
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));

        _dispatch = dispatch;
        _currentAccount = currentAccount;

        dispatch({ type: GET_DATA_INGRESO_AJUSTES });

        IngresoAjustes();
    }
}

export function aceptar(ajuste, accion, resetFields) {
    LogHelper.In(aceptar.name, cobranza, accion, resetFields);

    return (dispatch, getState) => {
        dispatch({ type: LOADING_INGRESO_AJUSTES });
        if (accion == "guardar") {
            IngresoAjusteManager.GuardarAjuste(ajuste, () => viewCallback(resetFields, dispatch));
        }
        else {
            IngresoAjusteManager.ActualizarAjuste(ajuste, () => viewCallback(resetFields, dispatch));
        }
    }
}

export function eliminar(ajuste, estado) {
    LogHelper.In(eliminar.name, ajuste, estado);

    return (dispatch, getState) => {
        let state = getState();
        ajuste.AjusteEstadoId = estado;
        ajuste.FechaCambioEstado = new Date();
        ajuste.UsuarioModif = state.sesion.executionContext.login;
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        dispatch({ type: ELIMINAR_INGRESO_AJUSTES });
        IngresoAjusteManager.EliminarAjuste(ajuste, () => IngresoAjustes());

    }
}

export function editar(ajuste) {
    LogHelper.In(editar.name, ajuste);

    return (dispatch, getState) => {
        dispatch({ type: EDITAR_INGRESO_AJUSTES, ajuste: ajuste });
    }
}


export function cambiarImporteConIva(numero) {
    LogHelper.In(cambiarImporteConIva.name, numero);

    return (dispatch, getState) => {
        dispatch({ type: CHANGE_IMPORTE_SIN_IVA, numero });
    }
}

export function confirmar(ajuste, estado) {
    LogHelper.In(confirmar.name, ajuste, estado);

    return (dispatch, getState) => {
        let state = getState();
        ajuste.AjusteEstadoId = estado;
        ajuste.FechaCambioEstado = new Date();
        ajuste.UsuarioUltModif = state.sesion.executionContext.login;
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        dispatch({ type: CONFIRMAR_INGRESO_AJUSTES });
        IngresoAjusteManager.ActualizarAjuste(ajuste, () => IngresoAjustes());
    }
}

export function denegar(ajuste, estado) {
    LogHelper.In(denegar.name, ajuste, estado);

    return (dispatch, getState) => {
        let state = getState();
        ajuste.AjusteEstadoId = estado;
        ajuste.FechaCambioEstado = new Date();
        ajuste.UsuarioUltModif = state.sesion.executionContext.login;
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        dispatch({ type: DENEGAR_INGRESO_AJUSTES });
        IngresoAjusteManager.ActualizarAjuste(ajuste, () => IngresoAjustes());

    }
}
/** 
 * Action que obtiene el estado inicial.
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_INGRESO_AJUSTES });
    }
}

export function expandirRow(id) {
    LogHelper.In(expandirRow.name, id);

    return (dispatch) => {
        dispatch({ type: EXPANDIR_ROW_INGRESO_AJUSTES, id: id });
    }
}

export function seleccionarMotivo(id) {
    LogHelper.In(seleccionarMotivo.name, id);
    return (dispatch) => {
       

        if (id != 0) {
            dispatch({ type: SELECT_MOTIVO_AJUSTE_COMBO, id });
            _seleccionarMotivo(id);
        } else {
            IngresoAjustes(id);
        }
    }
}

/*-------------------FUNCIONES AUXILIARES-------------------------*/
function _seleccionarMotivo(id) {
    let params = {
        'MOTIVO_AJUSTE_ID': id,
        'CUENTA_TARJETA_ID': _currentAccount
    };

    Engine1Proxy.AddDataSourcesRequests(params, 'GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.Execute((data) => _filterIngresoAjustesData(data, _dispatch, id), null, null, "CONSULTASOCIOS");
}

function _filterIngresoAjustesData(data, dispatch, motivoId) {
    let GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID = JSON.parse(data.GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID);

    let result = {
        debitoCredito: GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset0.Rows[0],
        tipoMoneda: GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset1.Rows,
        impactaPeriodo: GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset2.Rows[0],
        permiteIva: GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset3.Rows,
        tasaIva: GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset4.Rows,
        cuentaTarjetaId: _currentAccount
    }

    dispatch({ type: CHANGE_DATA_INGRESO_AJUSTES, data: result, motivoId });
}


function getIngresoAjustesData(data, dispatch, motivoId) {
    let GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE = JSON.parse(data.GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE);

    const GET_AJUSTES_DATOS_EXTRAS = JSON.parse(data.GET_AJUSTES_DATOS_EXTRAS);

    let result = {
        ajustes: GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE.Recordset0.Rows,
        tipoMoneda: GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE.Recordset1.Rows,
        fechaCobranza: GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE.Recordset2.Rows[0].FechaCobranza,
        ajusteMotivo: GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE.Recordset3.Rows,
        sucursalId: GET_AJUSTES_DATOS_EXTRAS.Recordset0.Rows[0] ? GET_AJUSTES_DATOS_EXTRAS.Recordset0.Rows[0].SucursalId : undefined,
        ajusteEstadoId: GET_AJUSTES_DATOS_EXTRAS.Recordset1.Rows[0] ? GET_AJUSTES_DATOS_EXTRAS.Recordset1.Rows[0].Id : undefined,
        ajusteOrigenId: GET_AJUSTES_DATOS_EXTRAS.Recordset2.Rows[0] ? GET_AJUSTES_DATOS_EXTRAS.Recordset2.Rows[0].Id : undefined,
        tarjetaCreditoId: GET_AJUSTES_DATOS_EXTRAS.Recordset3.Rows[0] ? GET_AJUSTES_DATOS_EXTRAS.Recordset3.Rows[0].Id : undefined,
        tarjetaVigencia: GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE.Recordset4.Rows,
        cuentaTarjetaId: _currentAccount
    }

    dispatch({ type: RECEIVE_DATA_INGRESO_AJUSTES, data: result, motivoId });
}

function viewCallback(resetFields, dispatch) {
    resetFields();
    dispatch({ type: LIMPIAR_INGRESO_AJUSTES });
    dispatch({ type: SUCCESS_INGRESO_AJUSTES });
    IngresoCobranzas();
}

function IngresoAjustes(motivoAjusteId) {
    let params = {
        'ADMINISTRADORA_ID': 1,
        'CUENTA_TARJETA_ID': _currentAccount
    };

    Engine1Proxy.AddDataSourcesRequests(params, 'GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_AJUSTES_DATOS_EXTRAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.Execute((data) => getIngresoAjustesData(data, _dispatch, motivoAjusteId), null, null, "CONSULTASOCIOS");
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/IngresoAjustes/actions/IngresoAjustesActions.js